import { Injectable } from "@angular/core";
import { Observable, fromEvent, merge, Subject, timer, Subscription } from "rxjs";

import * as moment from "moment";

export namespace IdleState {
	export type State = "WARNING" | "EXPIRED";
}
@Injectable({
	providedIn: "root"
})
export class SessionIdleService {

	private idle: Observable<Event>;
	private logoutTimer!: Subscription;
	private warningTimer!: Subscription;

	private readonly timeOutMilliSeconds = moment.duration(30, "minutes").asMilliseconds();
	private readonly warningMilliSeconds = moment.duration(29, "minutes").asMilliseconds();

	private idleSubscription: Subscription | undefined;

	public expired = new Subject<IdleState.State>();

	constructor() {
		this.idle = merge(
			fromEvent(document, "click"),
			fromEvent(document, "mousedown"),
			fromEvent(document, "keypress")
		);
	}

	public startWatching(): Observable<IdleState.State> {
		// Start the two timers
		this.startWarningTimer();
		this.startLogoutTimer();

		// Activate the timer reset subscription
		this.startIdleSubscription();

		return this.expired;
	}

	public stopWatching() {
		this.stopIdleSubscription();
		this.stopWarningTimer();
		this.stopLogoutTimer();
	}

	private startIdleSubscription() {
		if (!this.idleSubscription) {
			this.idleSubscription = this.idle.subscribe(() => {
				this.resetTimer();
			});
		}
	}

	private stopIdleSubscription() {
		if (!!this.idleSubscription) {
			this.idleSubscription.unsubscribe();
			this.idleSubscription = undefined;
		}
	}

	private startWarningTimer() {
		this.warningTimer = timer(this.warningMilliSeconds).subscribe(() => {
			this.expired.next("WARNING");
		});
	}

	private stopWarningTimer() {
		if (!!this.warningTimer) {
			this.warningTimer.unsubscribe();
		}
	}

	private startLogoutTimer() {
		this.logoutTimer = timer(this.timeOutMilliSeconds, this.timeOutMilliSeconds).subscribe(() => {
			this.expired.next("EXPIRED");
		});
	}

	private stopLogoutTimer() {
		if (!!this.logoutTimer) {
			this.logoutTimer.unsubscribe();
		}
	}

	private resetTimer() {
		// Stop the old two
		this.stopWarningTimer();
		this.stopLogoutTimer();
		// Start the new two
		this.startWarningTimer();
		this.startLogoutTimer();
	}

}
